import script from "./AppHeaderSettingsConfigsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderSettingsConfigsItem.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderSettingsConfigsItem.vue?vue&type=style&index=0&id=76ef7e38&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ef7e38"]])

export default __exports__